import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { key: 4 }

import { ref } from 'vue'
import BannerCard from './components/bannerCard.vue'
import CarousalCard from './components/carousalCard.vue'
import NoticeBar from './components/noticeBar.vue'
import GroupList from './components/groupList.vue'
import GamePanel from './components/gamePanel.vue'
import ContactService from './components/contactService.vue'
import FooterText from './components/footerText.vue'
import DownloadPanel from './components/downloadPanel.vue'
import MediaSection from './components/mediaSection.vue'
import PromotionPopup from '@/view/promotion/promotionPopup.vue'
import FloatButton from './components/floatButton.vue'
import { HomeData } from '@/view/home/supportScript'
import MainHeader from '../components/common/mainHeader.vue'
import MainFooter from '../components/common/mainFooter.vue'
import GamePopup from '@/view/game/gamePopup.vue'
import ProfilePopup from '@/view/profile/profilePopup.vue'
import PwaAntiBlockingPopup from '../components/common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../components/common/pwaStatusPopup.vue'
import SideNavbar from '../components/sideNav/sideNavbar.vue'
import { playClickSound } from '@/utils/media'
import ClaimListPopup from '../components/common/claimListPopup.vue'
import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'homeView',
  props: {
    dataSet: {}
  },
  emits: ['setFooterRef', 'goToGamePannel', 'openProfilePopup', 'isComponentVisible', 'installApp', 'isClosedPWA', 'setShowPWA', 'openPWAPopup', 'setGroupListRef', 'resetSelectedGroup', 'goToAgent', 'handleShowTreasurePopup'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const gamePopupRef = ref()
const profilePopupRef = ref()
const promotionRef = ref();
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const sideNavbarRef = ref()
const claimListPopupRef = ref()
const props = __props

const emits = __emit

const setFooterRef = (el: any) => {
    emits('setFooterRef',el)
};
const goToGamePannel = (id: number) => {
    sideNavbarRef.value.closeSidebar()
    emits('goToGamePannel',id)
}

const openProfilePopup = () => {
    emits('openProfilePopup')
}

const closeProfilePoup = () => {
    profilePopupRef.value.close()
}
const goToAgent = () => {
    emits('goToAgent')
}
const openSidebar = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return false; }
    playClickSound()
    sideNavbarRef.value.openSidebar()
}
const isComponentVisible = (item: any, menuId: string) => {
     return (
        item.component_id === props.dataSet.componentIdsInOrderConfig[menuId] && item.display
    );
};

const installApp = async () => {
    emits('installApp')
}
const isClosedPWA = async (value: any) => {
    emits('isClosedPWA', value)
}
const setShowPWA = async (value: any) => {
    emits('setShowPWA', value)
}

const openPWAPopup = () => {
    emits('openPWAPopup')
}

const setGroupListRef = (el: any) => {
    emits('setGroupListRef', el)
}
const resetSelectedGroup = () => {
    emits('resetSelectedGroup')
}

const gamePoupOpen = (id : number) => {    
    gamePopupRef.value.open(id);
}

const profilePoupOpen = (list : any) => {    
    profilePopupRef.value.open(list);
}

const pwaPoupOpen = () => {    
    pwaPopupRef.value.open()
}

const pwaStatusPoupOpen = (title : string) => {    
    pwaPopupStatusRef.value.open(title);
}
const handleShowTreasurePopup = (path: any) => {
    emits('handleShowTreasurePopup',path)
}
__expose({
    gamePoupOpen,
    profilePoupOpen,
    pwaStatusPoupOpen,
    pwaPoupOpen
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "home_page",
      style: _normalizeStyle({ paddingTop: _ctx.dataSet.isShowingPWA ? '100px' : '50px' })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.componentList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (isComponentVisible(item, 'header'))
            ? (_openBlock(), _createBlock(MainHeader, {
                key: 0,
                onIntallPWA: installApp,
                onIsClosedPWA: isClosedPWA,
                listGameData: _ctx.dataSet.groupList,
                onShowPWA: setShowPWA,
                onGoToProfile: openProfilePopup,
                itemData: item,
                onGoToGamePanel: goToGamePannel,
                onOpenSidebar: openSidebar
              }, null, 8, ["listGameData", "itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'banners'))
            ? (_openBlock(), _createBlock(CarousalCard, {
                key: 1,
                itemData: item
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'notice'))
            ? (_openBlock(), _createBlock(BannerCard, {
                key: 2,
                itemData: item
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'newsBar'))
            ? (_openBlock(), _createBlock(NoticeBar, {
                key: 3,
                itemData: item
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'gameGroups'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(GroupList, {
                  ref_for: true,
                  ref: el => setGroupListRef(el),
                  listData: _ctx.dataSet.groupList,
                  onGoToGamePanel: goToGamePannel,
                  itemData: item
                }, null, 8, ["listData", "itemData"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.groupList, (subitem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "home_game_panel",
                    key: index
                  }, [
                    _createVNode(GamePanel, {
                      groupImage: subitem.customIcon,
                      groupName: subitem.name,
                      gameList: subitem.games,
                      itemData: item,
                      onGoGamePannel: ($event: any) => (goToGamePannel(subitem.id))
                    }, null, 8, ["groupImage", "groupName", "gameList", "itemData", "onGoGamePannel"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'AppDownload'))
            ? (_openBlock(), _createBlock(DownloadPanel, {
                key: 5,
                itemData: item
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'shareMedia'))
            ? (_openBlock(), _createBlock(MediaSection, {
                key: 6,
                itemData: item
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'footerText'))
            ? (_openBlock(), _createBlock(FooterText, {
                key: 7,
                itemData: item
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'footer'))
            ? (_openBlock(), _createBlock(MainFooter, {
                key: 8,
                onGoToProfile: openProfilePopup,
                itemData: item,
                onProfileClose: closeProfilePoup,
                ref_for: true,
                ref: setFooterRef,
                onOpenPWA: openPWAPopup
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'contactService'))
            ? (_openBlock(), _createBlock(ContactService, { key: 9 }))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 4),
    _createVNode(FloatButton, {
      onOpenAgentPopup: goToAgent,
      onOpenPWA: openPWAPopup
    }),
    _createVNode(SideNavbar, {
      ref_key: "sideNavbarRef",
      ref: sideNavbarRef,
      listGameData: _ctx.dataSet.groupList,
      onIntallPWA: installApp,
      onGoToGamePanelSlide: goToGamePannel
    }, null, 8, ["listGameData"]),
    _createVNode(GamePopup, {
      ref_key: "gamePopupRef",
      ref: gamePopupRef,
      onResetSelectedGroup: resetSelectedGroup,
      onGoToProfile: openProfilePopup
    }, null, 512),
    _createVNode(ProfilePopup, {
      ref_key: "profilePopupRef",
      ref: profilePopupRef,
      onOpenAgentPopup: goToAgent
    }, null, 512),
    _createVNode(PromotionPopup, {
      ref_key: "promotionRef",
      ref: promotionRef,
      onOpenAgentPopup: goToAgent,
      onOpenPWA: openPWAPopup
    }, null, 512),
    _createVNode(PwaAntiBlockingPopup, {
      ref_key: "pwaPopupRef",
      ref: pwaPopupRef
    }, null, 512),
    _createVNode(PwaStatusPopup, {
      ref_key: "pwaPopupStatusRef",
      ref: pwaPopupStatusRef
    }, null, 512),
    (_unref(userStore).allActivityBonusPopup && _unref(userStore).claimActivityList.length > 0 && !_unref(userStore).pwaShowing && _unref(userStore).isInHome)
      ? (_openBlock(), _createBlock(ClaimListPopup, {
          key: 0,
          ref_key: "claimListPopupRef",
          ref: claimListPopupRef,
          onHandleShowTreasurePopup: handleShowTreasurePopup
        }, null, 512))
      : _createCommentVNode("", true)
  ], 64))
}
}

})